import {
  Button,
  Form,
  Icons,
  notification,
  RcFile,
  Upload,
  UploadFile,
  UploadProps,
} from '@pankod/refine-antd';
import { isLessThanSize, MAX_UPLOAD_FILE_SIZE_MB } from 'utilities/file';

interface VariantImageUploadFormItemProps {
  name: string | (string | number)[];
  label?: string;
  required?: boolean;
  maxCount?: number;
  listType?: 'text' | 'picture' | 'picture-card';
  defaultFileList?: UploadFile[];
  wrapperStyle?: React.CSSProperties;
}

export const VariantImageUploadFormItem: React.FC<VariantImageUploadFormItemProps> = ({
  name = 'images',
  label = '',
  required = false,
  maxCount = 1,
  listType = 'picture',
  defaultFileList = [],
  wrapperStyle,
}) => {
  const acceptedFileTypes = '.jpg,.jpeg,.png,.heic,.heif';
  const maxFileSize = MAX_UPLOAD_FILE_SIZE_MB;

  const beforeUpload = (file: RcFile) => {
    const isValidType = acceptedFileTypes
      .split(',')
      .some((type) => file.name.toLowerCase().endsWith(type.trim()));

    if (!isValidType) {
      notification.error({
        message: 'Invalid file type',
        description: `Please upload ${acceptedFileTypes} files only.`,
      });
      return Upload.LIST_IGNORE;
    }

    const isValidSize = file.size / 1024 / 1024 < maxFileSize;
    if (!isValidSize) {
      notification.error({
        message: 'File too large',
        description: `File must be smaller than ${maxFileSize}MB.`,
      });
      return Upload.LIST_IGNORE;
    }

    return true;
  };

  const normFile = (e: any) => {
    if (Array.isArray(e)) {
      return e;
    }
    return e?.fileList;
  };

  const uploadProps: UploadProps = {
    multiple: maxCount > 1,
    maxCount,
    beforeUpload,
    customRequest: ({ file, onSuccess, onError }: any) => {
      setTimeout(() => {
        const size = file?.size || 0;
        if (!isLessThanSize(size, maxFileSize)) {
          onError(`Image must smaller than ${maxFileSize}MB!`);
        } else {
          onSuccess('ok'); // Simulate a successful upload
        }
      }, 1000);
    },
    defaultFileList,
  };

  return (
    <Form.Item
      name={name}
      label={label}
      required={required}
      valuePropName="fileList"
      getValueFromEvent={normFile}
      rules={[
        {
          required: false,
          message: 'Please provide data',
        },
      ]}
      style={{ marginTop: '1.2rem' }}
    >
      <Upload {...uploadProps} accept={acceptedFileTypes} listType={listType} style={wrapperStyle}>
        <Button icon={<Icons.UploadOutlined />}>Upload</Button>
      </Upload>
    </Form.Item>
  );
};
